// Page to render components
export const TestPage = () => {
  return (
    <div className='flex flex-col'>
      <h1 className='mb-5'>Test Page</h1>
    </div>
  );
};
